import { KeyRound } from "lucide-react";
import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { PATHS } from "@/constants/paths";
import { cn } from "@/lib/utils";

import { AUTH_CONTROL_HEIGHT_CLASS } from "./constants/auth-controls";

interface ISsoButtonProps {
  className?: string;
  isCentered?: boolean;
}

export const SsoButton = memo(
  ({ className, isCentered = false }: ISsoButtonProps): React.ReactElement => {
    const navigate = useNavigate();
    const { t } = useTranslation("auth");

    const handleClick = useCallback((): void => {
      navigate(PATHS.AUTH.SSO);
    }, [navigate]);

    return (
      <Button
        variant="outline"
        size="lg"
        className={cn(
          AUTH_CONTROL_HEIGHT_CLASS,
          "w-full bg-background hover:bg-accent/30 hover:border-primary hover:text-foreground",
          isCentered ? "justify-center" : "justify-start pl-5",
          className,
        )}
        data-testid="sso-button"
        onClick={handleClick}
        type="button"
      >
        <KeyRound className="size-6 shrink-0" />
        {t("sso.submit")}
      </Button>
    );
  },
);
